export default {
  manageWeekendDeliveryDrawerTitle: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery_drawer.title',
    defaultMessage: 'Weekend delivery',
  },
  manageWeekendDeliveryDrawerClose: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery_drawer.close',
    defaultMessage: 'Close manage weekend delivery configuration',
  },
}
